export const BUS_EVENTS = {
  SHOW_ALERT: 'SHOW_ALERT',
  START_NEW_CONVERSATION: 'START_NEW_CONVERSATION',
  FOCUS_CUSTOM_ATTRIBUTE: 'FOCUS_CUSTOM_ATTRIBUTE',
  SCROLL_TO_MESSAGE: 'SCROLL_TO_MESSAGE',
  MESSAGE_SENT: 'MESSAGE_SENT',
  FETCH_LABEL_SUGGESTIONS: 'FETCH_LABEL_SUGGESTIONS',
  ON_MESSAGE_LIST_SCROLL: 'ON_MESSAGE_LIST_SCROLL',
  WEBSOCKET_DISCONNECT: 'WEBSOCKET_DISCONNECT',
  WEBSOCKET_RECONNECT: 'WEBSOCKET_RECONNECT',
  WEBSOCKET_RECONNECT_COMPLETED: 'WEBSOCKET_RECONNECT_COMPLETED',
  // Refetch de segurança achou canal morto (dado mudou sem evento realtime):
  // payload { family, since } — o ReconnectService rebusca a parte afetada.
  REALTIME_CHANNEL_STALE: 'REALTIME_CHANNEL_STALE',
  CAMPAIGN_STATUS_UPDATED: 'campaign:status_updated',
  // Relatório Custos com a Meta: o job de atribuição rodou e a conta teve
  // recibo/resposta nova — a tela aberta relê ({ through }).
  META_COSTS_UPDATED: 'meta_costs:updated',
  CAMPAIGN_DELETED: 'campaign:deleted',
  TOGGLE_REPLY_TO_MESSAGE: 'TOGGLE_REPLY_TO_MESSAGE',
  SHOW_TOAST: 'newToastMessage',
  NEW_CONVERSATION_MODAL: 'newConversationModal',
  INSERT_INTO_RICH_EDITOR: 'insertIntoRichEditor',
  INSERT_INTO_NORMAL_EDITOR: 'insertIntoNormalEditor',

  // Recontagem dos contadores da lista de conversas (ChatList ← actionCable)
  FETCH_CONVERSATION_STATS: 'fetch_conversation_stats',

  // Massiva (queda coletiva de rede) — opened/updated/closed do poll
  MASSIVA_EVENT: 'massiva:event',

  // Baileys
  BAILEYS_CONNECTED: 'baileys:connected',
  BAILEYS_DISCONNECTED: 'baileys:disconnected',
  BAILEYS_QR_GENERATED: 'baileys:qr_generated',
  BAILEYS_PAIRING_CODE_GENERATED: 'baileys:pairing_code_generated',
  BAILEYS_HISTORY_IMPORT_COMPLETED: 'baileys:history_import_completed',

  // Telephony
  TELEPHONY_CALL_STARTED: 'telephony:call_started',
  TELEPHONY_CALL_ENDED: 'telephony:call_ended',
  TELEPHONY_CALL_HISTORY_UPDATED: 'telephony:call_history_updated',
  TELEPHONY_SHOW_DIALER: 'telephony:show_dialer',
  TELEPHONY_INCOMING_CALL: 'telephony:incoming_call',
  TELEPHONY_TRANSFER_COMPLETED: 'telephony:transfer_completed',
  ASTERISK_QUEUE_CHANGED: 'asterisk:queue_changed',

  // Studio
  AI_DOCUMENT_UPDATED: 'ai:document_updated',
  VISION_ATTACH_FILE: 'vision:attach_file',
  // Reply box → Vision: abre o painel já perguntando ({ prompt }).
  VISION_ASK: 'vision:ask',

  // Sidebar (folders / custom views)
  SIDEBAR_OPEN_FOLDER_FILTER: 'sidebar:open_folder_filter',
  SIDEBAR_OPEN_AGENT_NEW: 'sidebar:open_agent_new',
  SIDEBAR_OPEN_LABEL_NEW: 'sidebar:open_label_new',
  SIDEBAR_OPEN_ATTRIBUTE_NEW: 'sidebar:open_attribute_new',
  SIDEBAR_OPEN_AGENT_BOT_NEW: 'sidebar:open_agent_bot_new',
  SIDEBAR_OPEN_CANNED_NEW: 'sidebar:open_canned_new',
  SIDEBAR_OPEN_CUSTOM_ROLE_NEW: 'sidebar:open_custom_role_new',
  SIDEBAR_OPEN_SLA_NEW: 'sidebar:open_sla_new',
  SIDEBAR_OPEN_CONTACT_NEW: 'sidebar:open_contact_new',

  // SLA estourado: actionCable → SlaMissedToaster (toast persistente no canto)
  SLA_MISSED_NOTIFICATION: 'sla:missed_notification',
  // Notificação lida/adiada/apagada em qualquer aba ou sessão (cable) — o
  // SlaMissedToaster fecha o toast que ficou velho
  NOTIFICATION_UPDATED: 'notification:updated',
  NOTIFICATION_DELETED: 'notification:deleted',
  NOTIFICATIONS_READ_ALL: 'notification:read_all',

  // WhatsApp SIP (Asterisk WebRTC for WhatsApp calls)
  WHATSAPP_SIP_INCOMING_CALL: 'whatsapp_sip:incoming_call',
  WHATSAPP_SIP_SHOW_DIALER: 'whatsapp_sip:show_dialer',
};
